function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M22.6178 20.823L16.9772 15.1756C19.8132 11.4842 19.5296 6.15226 16.1263 2.77641C14.2671 0.914952 11.8722 0 9.44576 0C7.01932 0 4.6244 0.914952 2.76519 2.77641C-0.921729 6.46776 -0.921729 12.4623 2.76519 16.1536C4.6244 18.0151 7.01932 18.93 9.44576 18.93C11.4625 18.93 13.4793 18.299 15.1494 17.0055L20.8216 22.6214C21.0737 22.8738 21.3888 23 21.7355 23C22.0506 23 22.3972 22.8738 22.6493 22.6214C23.122 22.1481 23.122 21.3278 22.6178 20.823ZM9.47727 16.3745C7.61805 16.3745 5.9164 15.6488 4.59289 14.3553C1.91436 11.6735 1.91436 7.28807 4.59289 4.57476C5.88489 3.28121 7.61805 2.55556 9.47727 2.55556C11.3365 2.55556 13.0381 3.28121 14.3616 4.57476C15.6852 5.86831 16.3784 7.60357 16.3784 9.46502C16.3784 11.3265 15.6536 13.0302 14.3616 14.3553C13.0696 15.6804 11.305 16.3745 9.47727 16.3745Z",
  fill: "white"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.9c1192fb.svg";
export { ForwardRef as ReactComponent };